import { render, staticRenderFns } from "./Civilian.vue?vue&type=template&id=c3cc1032&scoped=true"
import script from "./Civilian.vue?vue&type=script&lang=js"
export * from "./Civilian.vue?vue&type=script&lang=js"
import style0 from "./Civilian.vue?vue&type=style&index=0&id=c3cc1032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cc1032",
  null
  
)

export default component.exports